const UserList = ({name, age, phone, email}) => {
  return (
    <>
    <td>{name}</td>
    <td>{email}</td>
    <td>{phone}</td>
    <td>{age}</td>
    </>
  )
}

export default UserList